import React from 'react';
import Header from './Header';
import Footer from './Footer';

const Layout = ({ children }) => {
  return (
    <div className="bg-black text-white min-h-screen w-full overflow-x-hidden" style={{ 
      fontFamily: 'Bricolage Grotesque, sans-serif'
    }}>
      <Header />
      <main>{children}</main>
      <Footer />
    </div>
  );
};

export default Layout;